<template>
    <div v-if="isMaintenance" :data-skin="reskinning_style">
        <page-navbar-maintenance/>
        <router-view :key="$route.fullPath"/>
    </div>
    <div v-else-if="!loaded" :data-skin="reskinning_style" class="container">
        <div class="row">
            <div class="col-12 pt-3">
                <loading/>
            </div>
        </div>
    </div>
    <div class="app-body" ref="app" :data-skin="reskinning_style" v-else>
        <page-navbar/>
        <banners/>
        <div class="page-content">
            <breadcrumbs/>
            <router-view :key="$route.fullPath" class="page-content-data"/>
            <cart-review-order class="cart-review-order"/>
        </div>
        <page-footer v-if="footer"/>
    </div>
    <modals :data-skin="reskinning_style"></modals>
    <a v-if="widget_displayWidgetButton" href="#" class="d-none" :data-widget-trigger="widget_optionsJson">sw</a>
</template>

<script>

    import {mapGetters} from "vuex"

    import {isUnauthorizedResponse} from "@/helpers/api";
    import {AUTOLOGIN_ENABLED} from "@/constants";
    import {USER_TOKEN_STORAGE_KEY, USER_IMPERSONATOR_TOKEN_STORAGE_KEY} from "@/api/storage/local";
    import mixin_widget from "@mixins_widget";
    import mixin_reskinning from "@/mixins/reskinning";
    import mixin_events from "@/mixins/events";
    import {resolveQueryPageRoute} from "@/helpers/url";
    import {startAutoLogin} from "@/helpers/auth";

    import PageFooter from "@/components/Footer";
    import PageNavbar from "@/components/PageNavbar"
    import PageNavbarMaintenance from "@/components/PageNavbarMaintenance"
    import Breadcrumbs from "@/components/Breadcrumbs";
    import CartReviewOrder from "@/components/cart/CartReviewOrder";
    import Banners from "@/components/Banners";

    export default {
        mixins: [mixin_widget, mixin_reskinning, mixin_events],
        components: {
            Banners,
            CartReviewOrder,
            Breadcrumbs,
            PageFooter,
            PageNavbar,
            PageNavbarMaintenance
        },
        data() {

            return {
                loaded: false,
                footer: 1 == process.env.VUE_APP_FOOTER
            }
        },
        computed: {
            ...mapGetters({
                addresses: "user/address/items",
                orders: "user/orders/items",
                language: "i18n/language",
            }),
            isMaintenance() {

                return "maintenance" === this.$route.name;
            },
            isLoggedIn() {

                return !!this.$store.getters["user/token"];
            }
        },
        methods: {
            handlePageDestinationParameter() {

                const route = resolveQueryPageRoute(this.$route.query);

                if (route) {

                    this.$router.push(route);
                }
            },
            handleUnauthorizedRequest() {

                // Remove token from selected storage
                this.$storage.remove(USER_TOKEN_STORAGE_KEY);
                this.$storage.remove(USER_IMPERSONATOR_TOKEN_STORAGE_KEY);

                // Remove unauthorized interceptors
                this.$platform.disableUnauthorizedInterceptor();
                this.$order.disableUnauthorizedInterceptor();
                this.$delivery.disableUnauthorizedInterceptor();
                this.$auth.disableUnauthorizedInterceptor();

                // Logout user
                this.$store.dispatch("user/logout");

                if (true === AUTOLOGIN_ENABLED) {

                    // Start auto login process
                    startAutoLogin({
                        targeturi: this.$route.fullPath
                    });
                } else {

                    window.location = this.$router.resolve({name: "auth.login", query}).fullPath;
                }
            },
            listenMessage() {

                this.$broadcast.on(this.$broadcast.messages.refresh_addresses, () => {

                    if (this.$store.getters["user/isAuthenticated"] && this.$store.getters["user/country"] && this.$store.getters["user/profile/equipment_submitted"]) {

                        this.$store.dispatch("user/address/fetch");
                    }
                });
            }
        },
        watch: {
            $route(to) {

                this.breadcrumbs_processRouteMeta(to);
            },
            "$i18n.locale": {
                immediate: true,
                handler() {

                    this.breadcrumbs_processRouteMeta();
                    this.$store.dispatch("picker/setLocale", this.$i18n.locale);
                }
            },
            orders() {

                this.widget_refresh_delayed();
            },
            addresses() {

                this.widget_refresh_delayed();
            },
            language() {

                this.widget_refresh_delayed();
            },
        },
        mounted() {

            if ("maintenance" !== this.$route.name) {

                this.$order.setUnauthorizedInterceptor(this.handleUnauthorizedRequest);
                this.$platform.setUnauthorizedInterceptor(this.handleUnauthorizedRequest);
                this.$delivery.setUnauthorizedInterceptor(this.handleUnauthorizedRequest);
                this.$auth.setUnauthorizedInterceptor(this.handleUnauthorizedRequest);

                this.$store
                    .dispatch("i18n/fetch")
                    .then(language => {

                        this.$i18n.locale = language.value;

                        const impersonator = this.$storage.get(USER_IMPERSONATOR_TOKEN_STORAGE_KEY);
                        const auth = this.$storage.get(USER_TOKEN_STORAGE_KEY);

                        if (auth || impersonator) {

                            if (auth && impersonator) {

                                this.$store.commit("user/setImpersonatorToken", impersonator);
                            }

                            const authData = auth ? auth : impersonator;

                            this.$order.setToken(authData.token);
                            this.$platform.setToken(authData.token);
                            this.$delivery.setToken(authData.token);
                            this.$auth.setToken(authData.token);

                            this.$store
                                .dispatch("user/fetch", authData)
                                .then(() => {

                                    const forceSurvey = this.$store.getters["user/surveys/items"].find(i => true === i.forced);

                                    if (forceSurvey) {

                                        return this.$router.push({
                                            name: "surveys.view",
                                            params: {
                                                survey_id: forceSurvey._id
                                            }
                                        });
                                    }

                                    this.handlePageDestinationParameter();

                                })
                                .catch(error => {


                                    if (isUnauthorizedResponse(error)) {

                                        return this.handleUnauthorizedRequest();
                                    }

                                    if (error.response) {

                                        if (500 <= error.response.status) {

                                            return this.$router.push({name: "errors.500"});
                                        }

                                        if (500 > error.response.status && 400 <= error.response.status) {

                                            return this.$router.push({name: "errors.400"});
                                        }
                                    }

                                })
                                .finally(() => {

                                    this.widget_load();
                                    this.loaded = true
                                });
                        } else {

                            this.loaded = true;

                            this.handlePageDestinationParameter();
                        }
                    });
            }

            this.events_listen();

            this.reskinning_init();

            this.listenMessage();
        }
    }
</script>

<style lang="scss">

html,
body,
#app {
    height: 100%;
    min-height: 100%;
}

body {
    #app {
        .app-body {
            min-height: 100%;
            flex-grow: 1;
            display: flex;
            flex-direction: column;

            .page-content {
                display: flex;
                flex-direction: column;
                flex: 1 0 auto;
                position: relative;

                .breadcrumb {
                    order: 1;
                }

                .breadcrumb + .page-content-data {
                    margin-top: 0 !important; // Breadcrumb has own margins
                }

                .page-content-data {
                    order: 2;
                    margin-top: 1rem;

                    &.page-message:first-child {
                        margin-top: 0;
                    }
                }

                .cart-review-order {
                    @media (max-width: 578px) {
                        order: 0;
                    }
                }
            }
        }
    }
}
</style>
